import React, { useEffect, useMemo, useRef, useState } from "react";
import { Button, Col, Container, Dropdown, Form, Row } from "react-bootstrap";
// css
import styles from "./ClientDetail.module.scss";
import { generatePath, Link, useNavigate, useParams } from "react-router-dom";

// img
import p1 from "../../../../../Assets/images/user.png";
import AssignChecklistPop from "../../../../../components/Modals/AssignChecklistPop";
import { useAssignAssessmentDatesMutation, useDeleteAssessmentDateMutation, useGetMdtAssessmentDetailsQuery, useUpdateAssesmentMutation, useUpdateAssesmentStatusMutation, useUpdateCheckListStatusMutation } from "store/services/MDT/assessment";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { convertToMomentDate, dateFormat, getAge, successMessageToast, userFullName } from "helpers/common";
import { useGetMdtChatterStatusQuery, useGetMdtTermsListQuery, useGetMdtTherapistStatusListQuery, useLazyGetFileUrlQuery, useTherapistLookupQuery } from "store/services/utility";
import moment from "moment";
import { Breadcrumbs, CommonSelect, CommonToolTip, NoRecordFound, NoRecordFoundV2, RequiredFieldAstrick } from "components/Common/Common";
import { FieldArray, Formik } from "formik";
import { useDisciplineLookupQuery } from "store/services/disciplines";
import { useGetTherapistsListQuery } from "store/services/therapistProfiles";
import AppInputField from "components/shared/FormComponents/AppInputField";
import assignTherapistSchema from "./assignTherapist.schema";
import { useAssignTherapistMutation, useRemoveTherapistAssignmentMutation, useRemoveTherapistMutation } from "store/services/clientCaseLoads";
import LoadingOverlay from "components/shared/LoadingOverlay";
import ConfirmationPop from "components/Modals/ConfirmationPop";
import { DeleteIcon, EditIcon, MinusIcon, PlusIcon } from "Assets/icons";
import EditAssignedTherapistPopup from "components/Modals/EditAssignedTheripstPop";
import { array, object, string } from "yup";
import AddDocumentPop from "components/Modals/AddDocumentPop";
import { useUpdateHomeEducationClientMutation } from "store/services/clients/homeEducation.client";
import { useUpdateChatterClientMutation } from "store/services/clients/chatter.client";
import { useLazyPrivateClientDetailsQuery, useUpdatePrivateClientMutation } from "store/services/clients/private.client";
import { useUpdateSchoolClientMutation } from "store/services/clients/school.client";
import NotesComponent from "components/shared/FormComponents/NotesComponent";
import { CLIENT_NOTE_TYPES, SPECIALIZATION_OPTIONS } from "config/constants";
import { useLazyGetNoteQuery, useGetNoteQuery } from "store/services/note";
import { useLazyChatterClientDetailsQuery } from "store/services/clients/chatter.client";
import { useLazyGetHomeEducationClientDetailsQuery } from "store/services/clients/homeEducation.client";
import { useLazyGetSchoolClientDataQuery } from "store/services/clients/school.client";
import GuardianDetailList from "components/shared/GuardianDetailList";
import { useArchiveClientsMutation } from "store/services/archive";
import ChatComponent from "components/Chat";
import errorMessages from "utils/validation/errorMessages";
import { useDeleteResourceMutation } from "store/services/resource";
import { cloneDeep, compact, isEmpty } from "lodash";
import Attachments from "components/shared/Attachments";
import confirmDialog from "utils/confirmationDialog";
import { findCaseLoadByType, normalizeUrl } from "utils/common";
import LoadingButton from "components/shared/LoadingButton";
import { urlSchema } from "utils/validation/validationHelpers";
import IconButton from "components/shared/Buttons/IconButton";
import NotesComponentV2 from "pages/SideTabPages/Notes/NotesComponentV2";
import { CLIENT_DOCUMENTS_LIST, MDT_ASSESSMENT_DOCUMENTS, MDT_ASSESSMENT_LIST } from "config/paths";
import MdtAttachments from "components/shared/FormComponents/V2/MdtAttachments";
import CommonButton from "components/shared/FormComponents/V2/commonV2/CommonButton";
import NoRecordAddDetails from "components/NoRecordAddDetails";
import { Calendar, ChevronDown, ChevronUp, Clock, Edit, Edit2, PlusCircle, Trash2 } from "react-feather";
import AssessmentDatesModal from "../../../../../components/Modals/AssessmentDatesModal";
import ClientAttachments from "components/shared/FormComponents/V2/ClientAttachments/ClientAttachments";
import SeeMore from "components/SeeMore";
import AddPlus from "Assets/images/AddPlus";
import AddClientDocumentsModal from "components/Modals/AddClientDocumentsModal";

const MultidisciplinaryDetail = () => {
  ;

  const { id: assessmentId } = useParams();
  const navigate = useNavigate();

  const [assignChecklist, setAssignChecklist] = useState(false);
  const [showArchiveModal, setShowArchiveModal] = useState(false);
  const [selectedDiscipline, setSelectedDiscipline] = useState(null);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showEditAssesmentModal, setShowEditAssesmentModal] = useState(false);
  const [modalType, setModalType] = useState(null);
  const [currentItem, setCurrentItem] = useState(null)
  const [updateObject, setUpdateObject] = useState({});
  const [showDocumentModal, setShowDocumentModal] = useState(false);
  const [clientBaseDetails, setClientBaseDetails] = useState(null);
  const [clientBaseDetailsLoading, setClientBaseDetailsLoading] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [resourcesList, setResourcesList] = useState([]);
  const [isEditingLinks, setIsEditingLinks] = useState(false);
  const [clinicDate, setClinicDate] = useState("");
  const [showAssessmentDatesModal, setShowAssessmentDatesModal] = useState(false);
  const [selectedAssessmentDate, setSelectedAssessmentDate] = useState(null);
  const [expandedTherapistId, setExpandedTherapistId] = useState(null);
  const [clientsDocumentModal, setClientsDocumentModal] = useState(false)

  const [notes, setNotes] = useState([]);

  const inputRef = useRef(null);

  // MDT terms
  const { data: mdtTerms } = useGetMdtTermsListQuery();

  // Team lead list
  const { data: teamLeadList } = useTherapistLookupQuery();
  const teamLeadOptions = teamLeadList?.map(item => ({ value: item?.id, label: userFullName(item) }))

  // Practitioner specialization options
  const specializationOptions = useMemo(() => ([
    {
      value: "",
      label: "Please Select"
    },
    ...Object.entries(SPECIALIZATION_OPTIONS).map(([key, label]) => ({ value: key, label }))
  ]), []);

  // Check list status
  const { data: checkListStatusList } = useGetMdtTherapistStatusListQuery();

  // disciplines list
  const { data: disciplinesList, isLoading: disciplinesLoading } = useDisciplineLookupQuery();
  const disciplineOptions = disciplinesList?.map(discipline => ({ value: discipline.id, label: discipline.name })) || [];

  // Therapist list
  const { data: therapistListData, isFetching: therapistsLoading } = useGetTherapistsListQuery({ discipline: selectedDiscipline, type: "veteran" }, { skip: !selectedDiscipline });
  const therapistList = therapistListData?.records;
  const therapistOptions = therapistList?.map(therapist => ({ value: therapist.id, label: userFullName(therapist), email: therapist.email, icon: therapist.therapist_detail?.profile_picture, })) || [];

  const { data: clientDetails, isLoading, refetch, isFetching } = useGetMdtAssessmentDetailsQuery(assessmentId);
  const mdtStatusId = clientDetails?.clientCaseloads?.[0]?.mdt_status
  const caseLoadId = clientDetails?.clientCaseloads?.length && clientDetails?.clientCaseloads[0].id;
  const mdtCaseLoad = findCaseLoadByType(clientDetails?.clientCaseloads, "mdt");
  const clientType = clientDetails?.client_detail?.client_type;
  const clientId = clientDetails?.id;
  const clientCaseloadTrerapist = clientDetails?.clientCaseloads[0]?.clientCaseloadTherapist;
  const checkList = clientCaseloadTrerapist?.map(x => x.caseloadChecklist?.map(y => ({ ...y, therapist: x.clientCaseloadMapping?.[0], caseload_therapist_id: x?.id })))?.flat();

  const [assignTherapist, { isLoading: assignTherapistLoading }] = useAssignTherapistMutation();
  const [removeTherapistAssignment, { isLoading: removeTherapistLoading }] = useRemoveTherapistMutation();
  const [getFileUrl, { isLoading: getFileLoading }] = useLazyGetFileUrlQuery();
  const [updateCheckListStatus, { isLoading: updateChecklistLoading }] = useUpdateCheckListStatusMutation();
  const [assignAssessmentDates, { isLoading: assignAssessmentDatesLoading }] = useAssignAssessmentDatesMutation();
  const [deleteAssessmentDate, { isLoading: deleteAssessmentDateLoading }] = useDeleteAssessmentDateMutation();

  const [updateAssesment, { isLoading: updateAssessmentLoading }] = useUpdateAssesmentMutation();
  const [updateAssesmentStatus, { isLoading: updateAssessmentStatusLoading }] = useUpdateAssesmentStatusMutation();


  // Update documents
  const [updateHomeEducation, { isLoading: updateHomeEducationLoading }] = useUpdateHomeEducationClientMutation();
  const [updateChatter, { isLoading: updateChatterLoading }] = useUpdateChatterClientMutation();
  const [updatePrivate, { isLoading: updatePrivateLoading }] = useUpdatePrivateClientMutation();
  const [updateSchool, { isLoading: updateSchoolLoading }] = useUpdateSchoolClientMutation();

  // Client Details
  const [privateClientTrigger] = useLazyPrivateClientDetailsQuery();
  const [schoolClientTrigger] = useLazyGetSchoolClientDataQuery();
  const [homeClientTrigger] = useLazyGetHomeEducationClientDetailsQuery();
  const [chatterClientTrigger] = useLazyChatterClientDetailsQuery();
  const [removeFileApi, { isLoading: isRemoving }] = useDeleteResourceMutation();

  const [archiveClient, { isLoading: archiveLoading }] = useArchiveClientsMutation();

  // Notes
  const { data: notesData, isLoading: notesLoading, refetch: refetchNotes } = useGetNoteQuery({ clientId, moduleName: CLIENT_NOTE_TYPES[clientType] }, { skip: (!clientId || !clientType) });
  const { data: mdtStatusList } = useGetMdtChatterStatusQuery();
  const statusList = useMemo(() => {
    // return mdtStatusList?.length
    //   ? mdtStatusList.filter(status => status?.is_default === "yes")
    //   : [];
    if (mdtStatusList?.length > 0) {
      const isDefaultOptions = mdtStatusList.filter(status => status?.is_default === "yes");
      const options = isDefaultOptions?.length > 0 ? isDefaultOptions?.map((item) => ({ label: item?.title, value: item?.id })) : [];
      return options
    }
  }, [mdtStatusList]);
  const mdtStatusLabel = statusList?.find((x) => x?.value == mdtStatusId)?.label

  const handleChecklistPop = () => setAssignChecklist(!assignChecklist);

  // Url Schema
  const shareLinkSchema = object().shape({
    doc_share_link: array().of(urlSchema()).optional()
  });

  const handleAssignTherapist = async (values, { resetForm }) => {
    try {
      let payload = {
        ...values,
        caseload_id: values?.caseload_id,
        discipline_id: values?.discipline_id?.value,
        therapist_id: values?.therapist_id?.value,
        // data: {
        //   assessment_date: values?.assessment_date,
        //   meeting_time: values?.meeting_time
        // }
      }
      let { data, error } = await assignTherapist(payload);
      if (error) return;

      successMessageToast(data?.message);
      refetch();
      resetForm();
    } catch (err) {
      console.error("Error assigning therapist", err);
    }
  };

  const handleInputClick = () => {
    if (inputRef.current) {
      inputRef.current.showPicker();
    };
  };

  const getAssessmentDates = (therapistAssignment) => {
    const dates = therapistAssignment?.caseloadAssessmentDates
      || therapistAssignment?.caseload_assessment_dates
      || therapistAssignment?.caseloadAssessmentDate
      || therapistAssignment?.assessmentDates
      || therapistAssignment?.assessment_dates;

    if (Array.isArray(dates)) return dates;
    if (Array.isArray(therapistAssignment?.assessment_date)) return therapistAssignment.assessment_date;
    return therapistAssignment?.assessment_date ? [{ assessment_date: therapistAssignment.assessment_date }] : [];
  };

  const openAssessmentDatesModal = (therapistAssignment) => {
    setCurrentItem(therapistAssignment);
    setShowAssessmentDatesModal(true);
  };

  const handleAssignAssessmentDates = async (assessmentDates) => {
    if (!currentItem?.id || !assessmentDates.length) return;

    try {
      const result = await assignAssessmentDates({
        caseloadTherapistId: currentItem.id,
        assessment_dates: assessmentDates
      });

      if (result?.error) return;
      successMessageToast(result?.data?.message);
      setShowAssessmentDatesModal(false);
      refetch();
    } catch (err) {
      console.error("Error assigning assessment dates", err);
    }
  };

  const confirmationHandle = async () => {

    try {

      let result;
      setShowConfirmationModal(false);

      if (modalType == "delete") {
        result = await removeTherapistAssignment(currentItem?.id);

      } else if (modalType == "deleteAssessmentDate") {
        result = await deleteAssessmentDate(selectedAssessmentDate?.id || selectedAssessmentDate?.assessment_date_id);

      } else if (modalType == "update") {

        result = await updateCheckListStatus({
          id: currentItem.id,
          data: {
            caseload_therapist_id: currentItem.caseload_therapist_id,
            action: currentItem?.action,
            status: currentItem?.new_status,
            deadline: currentItem?.deadline,
            send_notification: "no"
          }
        });
      };

      if (result?.error) return;
      successMessageToast(result?.data?.message);
      setSelectedAssessmentDate(null);
      refetch();

    } catch (err) { console.log("Error delete therapist") }
  };

  const handleViewPdf = async (name) => {

    try {

      const result = await getFileUrl(name);
      if (result?.error) return;

      const url = result?.data
      if (url) window.open(url, '_blank');

    } catch (err) { console.error("Error assigning therapist", err); }
  }

  const getClientBaseDetails = async () => {

    try {

      setClientBaseDetailsLoading(true);
      let result = null;

      if (clientType == "private") result = await privateClientTrigger(clientId);
      else if (clientType == "school") result = await schoolClientTrigger(clientId);
      else if (clientType == "home_education") result = await homeClientTrigger(clientId);
      else if (clientType == "chatter") result = await chatterClientTrigger(clientId);

      setClientBaseDetailsLoading(false);
      if (result?.error) return;
      setClientBaseDetails(result?.data)

    } catch (err) { console.error("Error getting private client details", err); }
  };

  const handleUpdateAssessment = async (e, values = null) => {
    try {

      setShowEditAssesmentModal(false);
      let result = await updateAssesment({ data: values || updateObject, assessmentId })

      if (result?.error) return;
      successMessageToast(result?.data?.message);

    } catch (err) { console.log("Error delete therapist") }
  };

  const handleSaveClinicDate = () => {
    handleUpdateAssessment(null, { clinic_date: clinicDate });
  };

  const handleCheckChange = (item) => {

    const terms = [...clientDetails?.client_detail?.clientMdtDetail?.terms || []];

    if (!terms.includes(item)) terms.push(item);
    else {

      const index = terms.indexOf(item);
      if (index > -1) delete terms[index]
    }

    setUpdateObject({ ...updateObject, terms: terms.filter(Boolean) });
    setShowEditAssesmentModal(true);
  };

  const uploadDocuments = async (payload) => {
    try {

      setShowDocumentModal(false);

      const values = {
        documents: payload.documents,
        firstname: clientDetails?.firstname,
        lastname: clientDetails?.lastname,
        dob: clientDetails?.client_detail?.dob,
        gender: clientDetails?.client_detail?.gender,
        city_town: clientDetails?.client_detail?.city_town,
        status: clientDetails?.status,
      };

      let result = null;

      switch (clientType) {

        case "school": {
          values.grade = clientDetails?.client_detail?.grade;
          values.school_profile = clientBaseDetails?.client_detail?.client_school_detail?.school_profile;
          values.school_division = clientBaseDetails?.client_detail?.client_school_detail?.school_division;
          result = await updateSchool({ id: clientId, payload: values, });
          break;
        }

        case "home_education": result = await updateHomeEducation({ clientId, data: values, });
          break;

        case "private": {

          values.is_confirmed = clientBaseDetails?.client_detail?.client_private_detail?.is_confirmed;
          result = await updatePrivate({ clientId, data: values, });
          break;
        }

        case "chatter": result = await updateChatter({ clientId, data: values, });
          break;

        default: null;
      }

      if (result?.error) {
        console.error("Error creating School Client", result.error);
      } else {
        successMessageToast(result?.data?.message);
        refetch();
      }
    } catch (err) {
      console.error("Error adding document", err);
    }
  };

  const handlArchive = async () => {
    try {

      setShowArchiveModal(false);

      const result = await archiveClient({ id: clientId, clientType: clientType == "home_education" ? "home-education" : clientType });
      if (!result?.error) successMessageToast("Record has been updated successfully.");
      refetch();

    } catch (err) {
      console.error("error archiving peer", err);
    };
  };

  const handleDeleteResource = async () => {

    try {
      setShowDeleteModal(false);

      const list = cloneDeep(resourcesList);
      const index = list.findIndex(x => x.id == currentItem?.id);

      if (index > -1) {

        delete list[index];
        setResourcesList(list?.filter(Boolean));
        const result = await removeFileApi(currentItem?.id);
        if (result?.error) return;

        successMessageToast(result?.data?.message);
      };
    } catch (err) { console.error("Error deleting document", err); }
  };

  const handleSubmitShareLink = async (values, { setSubmitting }) => {
    try {
      let isConfirm = await confirmDialog();
      if (!isConfirm) {
        return;
      }

      setSubmitting(true);
      const newValue = values?.doc_share_link?.length ? values?.doc_share_link.join(",") : "";
      const updateData = { ...updateObject, doc_share_link: newValue }
      await handleUpdateAssessment(null, updateData);
      setUpdateObject(updateData);
      setIsEditingLinks(false);
    } catch (err) {
      console.error("Error saving shared link", err);
    } finally {
      setSubmitting(false);
    }
  }
  const handleStatusUpdate = async (statusId) => {
    try {
      const result = await updateAssesmentStatus({ caseLoadId, statusId });

      if (result?.error) console.error("Error updating mdt status", result.error);
      else successMessageToast(result?.data?.message);

    } catch (error) { console.error("Error updating mdt status", error) }
  };

  useEffect(() => {

    if (clientDetails) {

      getClientBaseDetails();

      const update = {};
      if (clientDetails?.client_detail?.clientMdtDetail?.doc_share_link) update["doc_share_link"] = clientDetails?.client_detail?.clientMdtDetail?.doc_share_link == "null" ? " " : clientDetails?.client_detail?.clientMdtDetail?.doc_share_link ? clientDetails?.client_detail?.clientMdtDetail?.doc_share_link : " ";
      // if (clientDetails?.client_detail?.clientMdtDetail?.team_lead) update["team_lead"] = clientDetails?.client_detail?.clientMdtDetail?.team_lead;
      if (clientDetails?.client_detail?.clientMdtDetail?.clinic_date) update["clinic_date"] = clientDetails?.client_detail?.clientMdtDetail?.clinic_date
      if (clientDetails?.client_detail?.clientMdtDetail?.dtc) update["dtc"] = clientDetails?.client_detail?.clientMdtDetail?.dtc;

      setUpdateObject(update);
      setClinicDate(clientDetails?.client_detail?.clientMdtDetail?.clinic_date || "");
      setResourcesList(clientDetails?.clientResources || []);
    };

  }, [clientDetails]);

  const breadcrumbItems = [
    { label: "Multidisciplinary Assessments", path: MDT_ASSESSMENT_LIST },
    { label: userFullName(clientBaseDetails) || "Client Details" },
  ];

  const isDisabled = false

  return (
    <>
      <AddClientDocumentsModal
        show={clientsDocumentModal}
        setShow={setClientsDocumentModal}
        clientId={clientId}
        refetch={refetch}
      />
      <ConfirmationPop
        confirmation={showDeleteModal}
        setConfirmation={setShowDeleteModal}
        confirmHandler={handleDeleteResource}
        type={"delete"}
      />
      <ConfirmationPop
        confirmation={showArchiveModal}
        setConfirmation={setShowArchiveModal}
        confirmHandler={handlArchive}
        type={clientBaseDetails?.status == "active" ? "archive" : "active"}
      />

      <AddDocumentPop
        show={showDocumentModal}
        setShow={setShowDocumentModal}
        handleSubmit={uploadDocuments}
      />

      <EditAssignedTherapistPopup
        show={showEditModal}
        setShow={setShowEditModal}
        initialValues={currentItem}
        refetch={refetch}
      />

      <AssignChecklistPop
        assignChecklist={assignChecklist}
        setAssignChecklist={setAssignChecklist}
        caseload_therapist_id={caseLoadId}
        therapistOptions={clientCaseloadTrerapist || []}
      />

      <ConfirmationPop
        confirmation={showConfirmationModal}
        setConfirmation={setShowConfirmationModal}
        confirmHandler={confirmationHandle}
        type={modalType === "update" ? "update" : "delete"}
      />

      <AssessmentDatesModal
        show={showAssessmentDatesModal}
        onHide={() => setShowAssessmentDatesModal(false)}
        assignedDates={getAssessmentDates(currentItem)}
        onSave={handleAssignAssessmentDates}
        isLoading={assignAssessmentDatesLoading}
      />

      <ConfirmationPop
        confirmation={showEditAssesmentModal}
        setConfirmation={setShowEditAssesmentModal}
        confirmHandler={handleUpdateAssessment}
        type="update"
      />

      <section
        className={`${styles.ClientDetail} position-relative ClientDetail`}
      >
        <Container fluid={true}>
          {
            isLoading ? <LoadingIndicator /> :
              <Row>
                {(assignTherapistLoading || removeTherapistLoading || getFileLoading || updateAssessmentLoading || updateChecklistLoading || clientBaseDetailsLoading || updateAssessmentStatusLoading || assignAssessmentDatesLoading || deleteAssessmentDateLoading) && <LoadingOverlay />}
                {(updateHomeEducationLoading || updateChatterLoading || updatePrivateLoading || updateSchoolLoading || archiveLoading || isFetching || isRemoving) && <LoadingOverlay />}
                <Row className="pt-3">
                  <Col lg="7">
                    <Breadcrumbs themeBlueV2 items={breadcrumbItems} />
                  </Col>
                  <Col lg="5">

                  </Col>
                </Row>

                <div style={{ marginTop: clientDetails?.status == 'active' ? "-10px" : '20px' }}>
                  <p>
                    <div className="d-flex align-items-end gap-2 proxima-regular">
                      {/* <div className="cursor-pointer" onClick={() => { !favouriteClientLoading && handleFavouriteClient(clientDetails?.client_detail?.id, clientDetails?.client_detail?.is_favorite ? 0 : 1) }}>{clientDetails?.client_detail?.is_favorite ? <Star fill="#315D99" stroke="#315D99" /> : <Star />}
                      </div> */}
                      <Row className="w-100 align-items-end">
                        <Col lg='7'>
                          <div className="d-flex gap-3 align-items-end">
                            <p className="twenty proxima-regular mb-0 d-flex gap-2" style={{ color: "#000", fontSize: "20px" }}>
                              {mdtStatusLabel != 'Active' && <div className="text-capitalize">{`${mdtStatusLabel}:`}</div>}{" "}{userFullName(clientDetails)}
                            </p>
                            <div style={{ width: "25%" }} className="reports-v2 classroom-conslutation">
                              <div className="w-100 align-items-center gap-3">
                                {/* <label className="discharge-screen-label mb-0">School</label> */}
                                <CommonSelect
                                  placeholder={"Choose one..."}
                                  option={statusList?.filter((x) => x?.value != mdtStatusId)}
                                  onChange={(e) => handleStatusUpdate(e?.value)}
                                  value={statusList?.find((x) => x?.value == mdtStatusId)}
                                  // onInputChange={(val) => handleSearch(val)}
                                  isFilterV2
                                  // isClearable
                                  styles={{
                                    container: (provided) => ({
                                      ...provided,
                                      width: "100%",
                                    }),
                                  }}
                                // isLoading={schoolsLoading}
                                />
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col lg='5'>
                          <div className="d-flex align-items-end justify-content-end gap-3">
                            {/* <div onClick={() => navigate(generatePath(CLIENT_ATTENDANCE_LIST, { clientId, clientType }))} className="text-end">
                              <span className="themeBlueV2 cursor-pointer ten ms-2 fw-medium fs-8" style={{ textDecoration: "underline", marginTop: clientDetails?.status != 'active' && "10px" }}>SEE ATTENDANCE DETAILS</span>
                            </div> */}
                            <div style={{ display: "flex", gap: "10px" }}>
                              {
                                <div className="mb-2" style={{ marginLeft: "auto", width: "150px", borderRadius: "4px", border: "1px solid #8F8F8F", padding: "10px 12px" }}>
                                  <Row className="mb-1">
                                    <Col lg='12'>
                                      <h3 className="black ten proxima-regular" style={{ fontWeight: "600" }}>ACCOUNT STATUS</h3>
                                    </Col>
                                    {/* <Col lg='6'>
                                      <h3 className="black ten proxima-regular text-start" style={{ fontWeight: "600" }}>DATE OF EXPIRY</h3>
                                    </Col> */}
                                  </Row>
                                  <Row>
                                    <Col lg='12'>
                                      <h2 className="forteen mb-0 proxima-regular text-capitalize" style={{ color: mdtStatusLabel == 'Active' && "#55A215", fontStyle: !["Active"]?.includes(mdtStatusLabel) && "italic" }}>{mdtStatusLabel}</h2>
                                    </Col>
                                    {/* <Col lg='6'>
                                      <h2 className="black mb-0 forteen  text-start">{clientDetails?.client_detail?.date_of_expiry ? dateFormat(clientDetails?.client_detail?.date_of_expiry, "MMM DD, YYYY") : "--"}</h2>
                                    </Col> */}
                                  </Row>
                                </div>
                              }
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </p>
                </div>

                <div className="session-header-date" style={{ backgroundColor: "#F5F5F5", padding: "11px 21px" }}>
                  <div className="d-flex align-items-center gap_20">
                    <div className="mt-1" style={{ width: "100%" }}>
                      <div className="d-flex justify-content-between">
                        <div style={{ display: "inline-flex" }} className="date-title justify-content-between">
                          <h6 className="mb-0" style={{ marginTop: "3px", fontSize: "14px" }}>CLIENT INFORMATION</h6>
                          <div className="d-flex align-items-center gap-2">
                            {/* <label style={{ fontSize: '10px', color: "purple", textDecoration: "underline" }} className="discharge-screen-label mb-0 ">SEE MORE </label> */}
                            <p className="mb-0 proxima_light" style={{ fontSize: "14px" }}>{userFullName(clientDetails?.record?.reportsPreflightTeacher)}</p>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex flex-wrap gap-3 align-items-center justify-content-between">
                        <div className="d-flex align-items-center gap-5">
                          <div>
                            <h5 className="discharge-screen-label" style={{ fontSize: "10px", color: "#000" }}>DATE OF BIRTH</h5>
                            <p className="mb-0 proxima_light" style={{ fontSize: "14px", color: "#000" }}>{clientDetails?.client_detail?.dob ? moment(clientDetails?.client_detail?.dob).format("DD/MM/YYYY") : "--"}</p>
                          </div>
                          <div>
                            <h5 className="discharge-screen-label" style={{ fontSize: "10px", color: "#000" }}>GENDER</h5>
                            <p className="mb-0 proxima_light text-capitalize" style={{ fontSize: "14px", color: "#000" }}>{clientDetails?.client_detail?.gender || "--"}</p>
                          </div>
                          <div>
                            <h5 className="discharge-screen-label" style={{ fontSize: "10px", color: "#000" }}>CITY/TOWN</h5>
                            <p className="mb-0 proxima_light" style={{ fontSize: "14px", color: "#000" }}>{clientDetails?.client_detail?.city_town || "--"}</p>
                          </div>
                        </div>

                        <div className="d-flex align-items-center gap-4">
                          <div>
                            <h5 className="discharge-screen-label text-end" style={{ fontSize: "10px", color: "#000" }}>GRADE</h5>
                            <p className="mb-0 text-end proxima_light" style={{ fontSize: "14px", color: "#000" }}>{clientDetails?.client_detail?.grade || "--"}</p>
                          </div>
                          <div>
                            <h5 className="discharge-screen-label text-end" style={{ fontSize: "10px", color: "#000" }}>AGE</h5>
                            <p className="mb-0 text-end proxima_light" style={{ fontSize: "14px", color: "#000" }}>{clientDetails?.client_detail?.dob ? getAge(clientDetails?.client_detail?.dob) : "--"}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {
                    clientType == 'school' &&
                    <div className="d-flex pt-3 align-items-center gap_20">
                      <div className="mt-1" style={{ width: "100%" }}>
                        <div className="date-title d-flex justify-content-between">
                          <h6 className="mb-0" style={{ marginTop: "3px", fontSize: "14px", color: "#000" }}>SCHOOL</h6>
                        </div>
                        <div className="d-flex flex-wrap gap-3 align-items-center justify-content-between">
                          <div className="d-flex align-items-center gap-5">
                            <div>
                              <h5 className="discharge-screen-label" style={{ fontSize: "10px", color: "#000" }}>SCHOOL DIVISION</h5>
                              <p className="mb-0 proxima_light" style={{ fontSize: "14px", color: "#000" }}>{clientBaseDetails?.client_detail?.client_school_detail?.client_school_division?.title || "--"}</p>
                            </div>
                            <div>
                              <h5 className="discharge-screen-label" style={{ fontSize: "10px", color: "#000" }}>SCHOOL</h5>
                              <p className="mb-0 proxima_light" style={{ fontSize: "14px", color: "#000" }}>{clientBaseDetails?.client_detail?.client_school_detail?.client_school?.name || "--"}</p>
                            </div>
                          </div>

                          <div className="d-flex align-items-center gap-4">
                            {/* <div>
                                            <h5 className="discharge-screen-label text-dark" style={{ fontSize: "10px" }}>CLASS ID</h5>
                                            <p className="mb-0 text-end proxima_light" style={{ fontSize: "14px" }}>{data?.client_detail?.grade || "--"}</p>
                                          </div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  }

                  <div className="d-flex align-items-center gap_20">
                    <div className="mt-1" style={{ width: "100%" }}>
                      {
                        clientDetails?.client_detail?.client_guardian_mapping?.map((item, index) => index <= 1 && <>
                          <div className="date-title d-flex justify-content-between pt-3">
                            <h6 className="mb-0" style={{ marginTop: "3px", fontSize: "14px", color: "#000" }}>{clientType != 'school' ? `PARENT ${index + 1}` : index == 0 ? "TEACHER" : "COORDINATOR"}</h6>
                          </div>
                          <div className="d-flex flex-wrap gap-3 align-items-center justify-content-between">
                            <div className="d-flex align-items-center gap-5">
                              <div>
                                <h5 className="discharge-screen-label" style={{ fontSize: "10px", color: "#000" }}>LAST NAME</h5>
                                <p className="mb-0 proxima_light" style={{ fontSize: "14px", color: "#000" }}>{item?.client_guardian?.lastname || "--"}</p>
                              </div>
                              <div>
                                <h5 className="discharge-screen-label" style={{ fontSize: "10px", color: "#000" }}>FIRST NAME</h5>
                                <p className="mb-0 proxima_light" style={{ fontSize: "14px", color: "#000" }}>{item?.client_guardian?.firstname || "--"}</p>
                              </div>
                              <div>
                                <h5 className="discharge-screen-label" style={{ fontSize: "10px", color: "#000" }}>EMAIL</h5>
                                <p className="mb-0 proxima_light" style={{ fontSize: "14px", color: "#000" }}>{item?.client_guardian?.email || "--"}</p>
                              </div>
                              <div>
                                <h5 className="discharge-screen-label" style={{ fontSize: "10px", color: "#000" }}>PHONE</h5>
                                <p className="mb-0 proxima_light" style={{ fontSize: "14px", color: "#000" }}>{item?.client_guardian?.phone || "--"}</p>
                              </div>
                            </div>
                          </div>
                        </>)
                      }
                    </div>
                  </div>

                </div>

                <Col
                  lg="6"
                  className=""
                  style={{ borderRight: "1px solid #3da0aa4f" }}
                >
                  <Row>
                    <Col lg="12" className="my-3">
                      {/* <div className="top d-flex align-items-center justify-content-between flex-wrap gap-10 pb-3">
                        <div className="right">
                          {clientBaseDetails?.client_detail?.client_school_detail?.client_school?.name ? <p
                            className="violetStatus status text-capitalize m-0 text-center d-flex align-items-center justify-content-center rounded-pill px-4 py-1 text-capitalize"
                            style={{ maxWidth: "max-content" }}
                          >
                            {clientBaseDetails?.client_detail?.client_school_detail?.client_school?.name}
                          </p> : null}
                        </div>
                      </div> */}
                      <Row>
                        <Col md="6" sm="6" className="my-2">
                          <div className="cardCstm p-3 bg-white shadow h-100">
                            <div className="reports-v2 classroom-conslutation w-100 align-items-center gap-3">
                              <label className="discharge-screen-label mb-0">Practitioner</label>
                              <CommonSelect
                                placeholder={"Choose one..."}
                                option={specializationOptions?.filter((item) => item?.value)}
                                onChange={e => {
                                  setUpdateObject({ ...updateObject, specialization: e.value });
                                  setShowEditAssesmentModal(true);
                                }} value={specializationOptions?.find(x => x.value == clientDetails?.client_detail?.clientMdtDetail?.specialization) || ""}
                                // onInputChange={(val) => handleSearch(val)}
                                isFilterV2
                                // isClearable
                                styles={{
                                  container: (provided) => ({
                                    ...provided,
                                    width: "100%",
                                  }),
                                }}
                              // isLoading={schoolsLoading}
                              />
                            </div>
                            {/* <Form.Select
                              className="form-control"
                              aria-label="Default select example"
                              value={specializationOptions?.find(x => x.value === clientDetails?.client_detail?.clientMdtDetail?.specialization)?.value || ""}
                              onChange={e => {
                                setUpdateObject({ ...updateObject, specialization: e.target.value });
                                setShowEditAssesmentModal(true);
                              }}
                            >
                              {
                                specializationOptions?.map((item, index) => {
                                  return <option key={index} value={item.value}>{item?.label}</option>
                                })
                              }
                            </Form.Select> */}
                          </div>
                        </Col>
                        <Col md="6" sm="6" className="my-2">
                          <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                            <label className="discharge-screen-label mb-0">DTC #</label>

                            <input
                              className="readonly-box"
                              defaultValue={clientDetails?.client_detail?.clientMdtDetail?.dtc || ""}
                              onChange={e => {
                                setUpdateObject({ ...updateObject, dtc: e.target.value });
                              }}
                            />
                            {typeof updateObject?.dtc !== "undefined" && (
                              <LoadingButton
                                // style={{
                                //   height: 40,
                                //   minWidth: "unset",
                                //   background: "#071E3E",
                                //   borderColor: "#071E3E",
                                // }}
                                className="blue-discharge-screen-btn"
                                onClick={() => setShowEditAssesmentModal(true)}
                              >
                                Save
                              </LoadingButton>
                            )}
                          </div>
                        </Col>
                      </Row>
                    </Col>
                    <Col lg="12" className="my-3">
                      {/* <h6 className="m-0 themeBlue fw-sbold">Notes</h6> */}
                      <NotesComponentV2
                        notes={notesData || []}
                        className={`${styles.formControl} form-control`}
                        module={CLIENT_NOTE_TYPES[clientType]}
                        client_id={clientId}
                      />
                    </Col>
                    {/* <GuardianDetailList
                      type="Parent"
                      guardianList={clientDetails?.client_detail?.client_guardian_mapping || []}
                    /> */}
                    {/* <GuardianDetailList
                      type="Teacher"
                      guardianList={clientDetails?.client_detail?.client_guardian_mapping || []}
                    /> */}
                    <Col lg="12" className="my-3">

                      <div className="py-2">
                        <h6 class="m-0 themeBlue fw-bold pb-2">
                          <div className="d-flex align-items-center">
                            <div>
                              {/* {" "}
                              <span class="" style={{ color: " rgb(61, 160, 170)" }}>
                                ■
                              </span>{" "} */}
                              Share a link
                            </div>
                            {!isEditingLinks && (
                              <CommonToolTip
                                text={"Edit"}
                                component={
                                  <div style={{ marginLeft: "10px" }}>
                                    <IconButton
                                      onClick={() => setIsEditingLinks(true)}
                                    >
                                      <Edit size={16} />
                                    </IconButton>
                                  </div>
                                }
                              />
                            )}
                          </div>
                        </h6>
                        <Formik
                          initialValues={{
                            doc_share_link:
                              updateObject?.doc_share_link?.split(",")?.filter(Boolean) || [""],
                          }}
                          validationSchema={shareLinkSchema}
                          onSubmit={handleSubmitShareLink}
                          enableReinitialize
                        >
                          {({ values, handleSubmit, isSubmitting }) => (
                            <Form className="align-items-center w-100" onSubmit={handleSubmit}>
                              <Row>
                                <Col lg="12">
                                  {isEditingLinks ? (
                                    <FieldArray name="doc_share_link">
                                      {({ remove, push }) => (
                                        <ul className="list-unstyled ps-0 mb-0 w-100">
                                          {values.doc_share_link.length === 0 ? (
                                            <Row className="mt-2 w-100 align-items-center">
                                              <Col lg="11">
                                                <div className="w-100 d-flex">
                                                  <AppInputField
                                                    type="text"
                                                    placeholder="Add link to a report"
                                                    className="form-control"
                                                    name={`doc_share_link.0`}
                                                  />
                                                </div>
                                              </Col>
                                              <Col lg="1 p-0">
                                                <Button
                                                  className="border-0 p-0"
                                                  variant="transparent"
                                                >
                                                  <PlusIcon onClick={() => push("")} />
                                                </Button>
                                              </Col>
                                            </Row>
                                          ) : (
                                            values.doc_share_link.map((area, index) => {
                                              const isLastItem =
                                                index === values.doc_share_link.length - 1;
                                              return (
                                                <Row
                                                  className="mt-2 w-100 align-items-center"
                                                  key={index}
                                                >
                                                  <Col lg="11">
                                                    <div className="w-100 d-flex">
                                                      <AppInputField
                                                        type="text"
                                                        placeholder="Add link to a report"
                                                        className="readonly-box"
                                                        name={`doc_share_link.${index}`}
                                                      />
                                                    </div>
                                                  </Col>
                                                  <Col lg="1 p-0">
                                                    <Button
                                                      className="border-0 p-0"
                                                      variant="transparent"
                                                    >
                                                      {isLastItem ? (
                                                        values.doc_share_link.length > 1 ? (
                                                          <div className="d-flex">
                                                            <PlusIcon onClick={() => push("")} />
                                                            <MinusIcon
                                                              onClick={() => remove(index)}
                                                            />
                                                          </div>
                                                        ) : (
                                                          <PlusIcon onClick={() => push("")} />
                                                        )
                                                      ) : (
                                                        <MinusIcon onClick={() => remove(index)} />
                                                      )}
                                                    </Button>
                                                  </Col>
                                                </Row>
                                              );
                                            })
                                          )}
                                        </ul>
                                      )}
                                    </FieldArray>
                                  ) : (
                                    // view mode
                                    !isEmpty(compact(values.doc_share_link)) ? values.doc_share_link.map((link, index) => (
                                      <p className="m-0 p-3 mt-2" style={{ cursor: "default", border: "1px solid rgb(50, 93, 153)" }}>
                                        <a
                                          style={{ wordWrap: "break-word", color: "rgb(50, 93, 153)" }}
                                          href={normalizeUrl(link)}
                                          target="_blank"
                                          className=""
                                        >
                                          {link}
                                        </a>
                                      </p>
                                    )) : (
                                      <NoRecordFoundV2 />
                                    )
                                  )}
                                </Col>

                                <Col lg="12 mt-2">
                                  {isEditingLinks && (
                                    // <LoadingButton
                                    //   type="submit"
                                    //   style={{
                                    //     height: 40,
                                    //     minWidth: "unset",
                                    //     background: "#071E3E",
                                    //     borderColor: "#071E3E",
                                    //   }}
                                    //   className="d-flex px-3 align-items-center justify-content-center commonBtn"
                                    //   isLoading={isSubmitting}
                                    // >
                                    //   Save

                                    // </LoadingButton>
                                    <LoadingButton
                                      type="submit"
                                      className="blue-discharge-screen-btn"
                                      isLoading={isSubmitting}
                                    >
                                      Save
                                    </LoadingButton>
                                  )}
                                </Col>
                              </Row>
                            </Form>
                          )}
                        </Formik>
                      </div>
                    </Col>

                    <Col lg="12" className="my-3">
                      <div className="mt-4" style={{ border: "1px solid #C7C7C7", padding: "12px", borderRadius: "4px" }}>
                        <Row>
                          <Col lg='8'>
                            <div className="d-flex gap-2">
                              <h6 onClick={() => navigate(generatePath(MDT_ASSESSMENT_DOCUMENTS, { clientId, clientType: clientType == 'home_education' ? "home-education" : clientType }))} className="mb-0 forteen proxima-regular" style={{ marginTop: "3px" }}>DOCUMENTS
                                {/* <span className="themeBlue cursor-pointer ten ms-2" style={{ textDecoration: "underline" }}>SHOW ALL</span> */}
                              </h6>
                              <SeeMore onClick={() => navigate(generatePath(MDT_ASSESSMENT_DOCUMENTS, { clientId, clientType: clientType == 'home_education' ? "home-education" : clientType }))} title='SHOW ALL' />
                            </div>
                          </Col>
                          <Col lg='4' className="text-end">
                            {/* <svg style={{ opacity: data?.status == "discharged" && "0.5" }} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 32 32" fill="none" className="mx-1"><mask id="mask0_0_12941" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32" style={{ maskType: "alpha" }}><rect width="32" height="32" fill="#D9D9D9"></rect></mask><g mask="url(#mask0_0_12941)"><path d="M14.6667 17.3337V21.3337C14.6667 21.7114 14.7945 22.0281 15.0501 22.2837C15.3056 22.5392 15.6223 22.667 16.0001 22.667C16.3779 22.667 16.6945 22.5392 16.9501 22.2837C17.2056 22.0281 17.3334 21.7114 17.3334 21.3337V17.3337H21.3334C21.7112 17.3337 22.0279 17.2059 22.2834 16.9503C22.539 16.6948 22.6667 16.3781 22.6667 16.0003C22.6667 15.6225 22.539 15.3059 22.2834 15.0503C22.0279 14.7948 21.7112 14.667 21.3334 14.667H17.3334V10.667C17.3334 10.2892 17.2056 9.97255 16.9501 9.71699C16.6945 9.46144 16.3779 9.33366 16.0001 9.33366C15.6223 9.33366 15.3056 9.46144 15.0501 9.71699C14.7945 9.97255 14.6667 10.2892 14.6667 10.667V14.667H10.6667C10.289 14.667 9.9723 14.7948 9.71675 15.0503C9.46119 15.3059 9.33342 15.6225 9.33342 16.0003C9.33342 16.3781 9.46119 16.6948 9.71675 16.9503C9.9723 17.2059 10.289 17.3337 10.6667 17.3337H14.6667ZM16.0001 29.3337C14.1556 29.3337 12.4223 28.9837 10.8001 28.2837C9.17786 27.5837 7.76675 26.6337 6.56675 25.4337C5.36675 24.2337 4.41675 22.8225 3.71675 21.2003C3.01675 19.5781 2.66675 17.8448 2.66675 16.0003C2.66675 14.1559 3.01675 12.4225 3.71675 10.8003C4.41675 9.1781 5.36675 7.76699 6.56675 6.56699C7.76675 5.36699 9.17786 4.41699 10.8001 3.71699C12.4223 3.01699 14.1556 2.66699 16.0001 2.66699C17.8445 2.66699 19.5779 3.01699 21.2001 3.71699C22.8223 4.41699 24.2334 5.36699 25.4334 6.56699C26.6334 7.76699 27.5834 9.1781 28.2834 10.8003C28.9834 12.4225 29.3334 14.1559 29.3334 16.0003C29.3334 17.8448 28.9834 19.5781 28.2834 21.2003C27.5834 22.8225 26.6334 24.2337 25.4334 25.4337C24.2334 26.6337 22.8223 27.5837 21.2001 28.2837C19.5779 28.9837 17.8445 29.3337 16.0001 29.3337Z" fill="#315D99"></path></g></svg> */}
                            <AddPlus isDisabled={isDisabled} onClick={() => clientDetails?.status != "discharged" && setClientsDocumentModal(true)} />
                          </Col>
                        </Row>
                        <ClientAttachments
                          isPage={false}
                          resources={clientDetails?.clientResources || []}
                          clientId={clientId}
                          refetch={refetch}
                          clientType={clientType}
                          limit={4}
                          onClick={() => clientDetails?.status != "discharged" && setClientsDocumentModal(true)}
                          isDisabled={isDisabled}
                        />
                      </div>
                    </Col>

                    {/* <Col lg="12" className="my-3">
                      <ChatComponent
                        caseLoadId={caseLoadId}
                      />
                    </Col> */}
                    <MdtAttachments
                      hideAttachments={true}
                      resources={clientDetails?.clientResources || []}
                      uploadDocuments={uploadDocuments}
                    />

                  </Row>
                </Col>
                <Col lg="6" className="">
                  <Row>
                    <Col lg="12" className="my-2">
                      <div className="d-flex align-items-center justify-content-between flex-wrap gap-10 border-bottom pb-2">
                        <h6 className="m-0 themeBlue fw-bold">
                          Multidisciplinary Team Assessments
                        </h6>
                        <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10">
                          <li className="">
                            <CommonButton
                              text="Assign New checklist"
                              style={{ color: "#fff", background: "#315D99" }}
                              onClick={handleChecklistPop}

                            />
                            {/* <Button
                              onClick={handleChecklistPop}
                              className="d-flex align-items-center justify-content-center commonBtn "
                              style={{ height: 40, fontSize: 12 }}
                            >
                              <span className="icn me-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="17"
                                  height="17"
                                  viewBox="0 0 17 17"
                                  fill="none"
                                >
                                  <path
                                    d="M7.57947 12.2599H9.13945V9.13993H12.2594V7.57996H9.13945V4.46H7.57947V7.57996H4.45951V9.13993H7.57947V12.2599ZM8.35946 16.1598C7.28047 16.1598 6.26649 15.9551 5.3175 15.5456C4.36851 15.1361 3.54303 14.5804 2.84104 13.8784C2.13905 13.1764 1.58331 12.3509 1.17381 11.4019C0.764317 10.4529 0.55957 9.43893 0.55957 8.35995C0.55957 7.28096 0.764317 6.26698 1.17381 5.31799C1.58331 4.369 2.13905 3.54352 2.84104 2.84153C3.54303 2.13954 4.36851 1.58379 5.3175 1.1743C6.26649 0.764806 7.28047 0.560059 8.35946 0.560059C9.43844 0.560059 10.4524 0.764806 11.4014 1.1743C12.3504 1.58379 13.1759 2.13954 13.8779 2.84153C14.5799 3.54352 15.1356 4.369 15.5451 5.31799C15.9546 6.26698 16.1593 7.28096 16.1593 8.35995C16.1593 9.43893 15.9546 10.4529 15.5451 11.4019C15.1356 12.3509 14.5799 13.1764 13.8779 13.8784C13.1759 14.5804 12.3504 15.1361 11.4014 15.5456C10.4524 15.9551 9.43844 16.1598 8.35946 16.1598ZM8.35946 14.5999C10.1014 14.5999 11.5769 13.9954 12.7859 12.7864C13.9949 11.5774 14.5994 10.1019 14.5994 8.35995C14.5994 6.61797 13.9949 5.14249 12.7859 3.93351C11.5769 2.72453 10.1014 2.12004 8.35946 2.12004C6.61748 2.12004 5.142 2.72453 3.93302 3.93351C2.72404 5.14249 2.11955 6.61797 2.11955 8.35995C2.11955 10.1019 2.72404 11.5774 3.93302 12.7864C5.142 13.9954 6.61748 14.5999 8.35946 14.5999Z"
                                    fill="white"
                                  />
                                </svg>
                              </span>{" "}
                              Assign New checklist
                            </Button> */}
                          </li>
                        </ul>
                      </div>
                    </Col>
                    <Col lg="12" className="my-2">
                      <div className="d-flex align-items-center justify-content-between gap-10 flex-wrap pb-3">
                        <h6 className="m-0 fw-sbold themeBlue">
                          Select Team Member
                        </h6>
                        <div className="right d-flex align-items-center gap-10 flex-wrap">
                          <h6
                            className="m-0 pb-1 fw-sbold themeBlue"
                            style={{ fontSize: 14 }}
                          >
                            Clinic Date
                          </h6>
                          <input
                            ref={inputRef}
                            onClick={handleInputClick}
                            type="date"
                            value={clinicDate}
                            className={`readonly-box w-auto`}
                            style={{ height: 40, fontSize: 12 }}
                            onChange={(event) => setClinicDate(event.target.value)}
                          />
                          {clinicDate && (
                            <CommonButton
                              onClick={() => setClinicDate("")}
                              style={{ height: 40, minWidth: "unset", padding: "6px 12px" }}
                              text="Clear"
                            />
                          )}
                          {clinicDate !== (clientDetails?.client_detail?.clientMdtDetail?.clinic_date || "") && (
                            <LoadingButton
                              isLoading={updateAssessmentLoading}
                              onClick={handleSaveClinicDate}
                              className="d-flex align-items-center justify-content-center"
                              style={{ height: 40, minWidth: "unset", borderRadius: "0", background: "#315D99", borderColor: "#315D99" }}
                            >
                              Save
                            </LoadingButton>
                          )}
                        </div>
                      </div>
                      <Formik
                        initialValues={{
                          caseload_id: caseLoadId,
                          discipline_id: "",
                          therapist_id: "",
                          assessment_date: "",
                          meeting_time: ""
                        }}
                        validationSchema={assignTherapistSchema}
                        onSubmit={handleAssignTherapist}
                        enableReinitialize
                      >
                        {({
                          handleSubmit,
                          setFieldValue,
                        }) => (
                          <Form className="p-3 mb-3"
                            style={{ background: "#F3F3F3" }} onSubmit={handleSubmit}>
                            <Row className="mb-3">
                              <Col lg="6" className="">
                                {/* <h6
                                  className="m-0 pb-1 fw-sbold themeBlue d-flex"
                                  style={{ fontSize: 14 }}
                                >
                                  Discipline
                                  <RequiredFieldAstrick />
                                </h6> */}
                                <div className="reports-v2 classroom-conslutation w-100 align-items-center gap-3">
                                  <label>Discipline <RequiredFieldAstrick /></label>
                                  <CommonSelect
                                    name="discipline_id"
                                    placeholder="Select Discipline"
                                    classNamePrefix={"khan"}
                                    option={disciplineOptions}
                                    onChange={(selected) => {
                                      setSelectedDiscipline(selected?.value);
                                      setFieldValue("therapist_id", null);
                                    }}
                                    isLoading={disciplinesLoading}
                                  />
                                </div>
                              </Col>
                              <Col lg="6" className="">
                                {/* <h6
                                  className="m-0 pb-1 fw-sbold themeBlue d-flex"
                                  style={{ fontSize: 14 }}
                                >
                                  Therapist
                                  <RequiredFieldAstrick />

                                </h6> */}
                                <div className="reports-v2 classroom-conslutation w-100 align-items-center gap-3">
                                  <label>Therapist <RequiredFieldAstrick /></label>
                                  <CommonSelect
                                    name="therapist_id"
                                    placeholder="Select Therapist"
                                    className={`${styles.formControl}`}
                                    option={therapistsLoading ? [] : therapistOptions}
                                    isLoading={therapistsLoading}
                                  />
                                </div>
                              </Col>
                            </Row>
                            {/* <Row className="mb-3">
                              <Col lg="6" className="">
                                <h6
                                  className="m-0 pb-1 fw-sbold themeBlue d-flex"
                                  style={{ fontSize: 14 }}
                                >
                                  Assessment Date
                                  <RequiredFieldAstrick />
                                </h6>
                                <AppInputField
                                  name="assessment_date"
                                  type="date"
                                  className={`${styles.formControl} form-control`}
                                  style={{
                                    borderColor: "#B46C9F",
                                    borderRadius: 10,
                                    fontSize: 12,
                                    height: "55px"
                                  }}
                                // min={moment().add(1, 'day').format("YYYY-MM-DD")}
                                />
                              </Col>
                              <Col lg="6" className="">
                                <h6
                                  className="m-0 pb-1 fw-sbold themeBlue d-flex"
                                  style={{ fontSize: 14 }}
                                >
                                  Meeting Time
                                  <RequiredFieldAstrick />
                                </h6>
                                <AppInputField
                                  type="time"
                                  name="meeting_time"
                                  className={`${styles.formControl} bg-transparent form-control`}
                                  style={{
                                    borderColor: "#B46C9F",
                                    borderRadius: 10,
                                    fontSize: 12,
                                    height: "55px"
                                  }}
                                />
                              </Col>
                            </Row> */}
                            <CommonButton
                              type="submit"
                              // style={{
                              //   height: 40,
                              //   minWidth: "unset",
                              //   background: "#071E3E",
                              //   borderColor: "#071E3E",
                              // }}
                              style={{ color: "#fff", background: "#315D99" }}
                              text="Save"
                            >
                            </CommonButton>
                          </Form>
                        )}
                      </Formik>
                      <div style={{ border: "1px solid #C7C7C7", padding: "12px", borderRadius: "4px" }}>
                        <Row>
                          <Col lg='8'>
                            <div className="d-flex gap-2">
                              <h6 className="mb-0 forteen proxima-regular" style={{ marginTop: "3px" }}>ASSIGNED CLINICIANS
                              </h6>
                            </div>
                          </Col>
                          <Col lg='4' className="text-end">
                          </Col>
                        </Row>

                        <div
                          className={`${styles.tableResponsive} tableResponsive table-responsive mb-3 pb-0`}
                        >
                          <table className="w-100">
                            <thead>
                              <tr>
                                <th
                                  className="fw-medium proxima"
                                  style={{ padding: "15px 10px", borderBottom: "2px solid #315D99", cursor: "pointer" }}
                                >
                                  <div>
                                    THERAPIST
                                  </div>
                                </th>
                                <th
                                  className="fw-medium proxima"
                                  style={{ padding: "15px 10px", width: "120px", borderBottom: "2px solid #315D99", cursor: "pointer" }}
                                >
                                  <div>
                                    DISCIPLINE
                                  </div>
                                </th>
                                <th
                                  className="fw-medium proxima"
                                  style={{ padding: "15px 10px", borderBottom: "2px solid #315D99", cursor: "pointer" }}
                                >
                                  <div className={`d-flex gap-2 align-items-center`}>
                                    ACTION
                                  </div>
                                </th>
                                <th
                                  className="fw-medium proxima"
                                  style={{ padding: "15px 10px", borderBottom: "2px solid #315D99", cursor: "pointer" }}
                                >
                                  {/* <div className={`d-flex gap-2 align-items-center`}>
                                    DETAILS
                                  </div> */}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {clientCaseloadTrerapist?.length > 0 ?
                                clientCaseloadTrerapist?.map((item, index) => {
                                  const therapistRowId = item?.id || index;
                                  const isExpanded = expandedTherapistId === therapistRowId;

                                  return (
                                    <React.Fragment key={therapistRowId}>
                                      <tr>
                                        <td
                                          style={{ padding: "15px 10px", borderRadius: 0, borderBottom: isExpanded ? 0 : "1px solid #8F8F8F" }}
                                        >
                                          <p className="p-0 m-0">{userFullName(item?.clientCaseloadMapping?.[0]?.caseTherapist)}</p>
                                        </td>
                                        <td
                                          className="proxima"
                                          style={{ padding: "15px 10px", borderRadius: 0, borderBottom: isExpanded ? 0 : "1px solid #8F8F8F" }}
                                        >
                                          <p className="p-0 m-0">{item?.caseDiscipline?.assign_term || "--"}</p>
                                        </td>
                                        <td
                                          style={{ padding: "15px 10px", borderRadius: 0, borderBottom: isExpanded ? 0 : "1px solid #8F8F8F", textAlign: 'center' }}
                                        >
                                          {/* <Edit
                                            onClick={() => {
                                              setCurrentItem(item);
                                              setShowEditModal(true);
                                            }}
                                            className="mx-1 cursor-pointer"
                                            size={16}
                                          /> */}
                                          <Trash2 onClick={() => {
                                            setCurrentItem(item);
                                            setModalType("delete")
                                            setShowConfirmationModal(true);
                                          }} size={16} className="cursor-pointer" />
                                        </td>
                                        <td
                                          style={{ padding: "15px 10px", borderRadius: 0, borderBottom: isExpanded ? 0 : "1px solid #8F8F8F" }}
                                        >
                                          <Button
                                            type="button"
                                            variant="transparent"
                                            className="p-0 d-flex align-items-center themeBlue"
                                            onClick={() => setExpandedTherapistId(isExpanded ? null : therapistRowId)}
                                            title={isExpanded ? "Hide assessment dates" : "Show assessment dates"}
                                            aria-label={isExpanded ? "Hide assessment dates" : "Show assessment dates"}
                                          >
                                            {isExpanded ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
                                          </Button>
                                        </td>
                                      </tr>
                                      {isExpanded && (
                                        <tr>
                                          <td colSpan="4" style={{ padding: "0 10px 15px", borderBottom: "1px solid #8F8F8F" }}>
                                            <div style={{ background: "#F5F5F5", border: "1px solid #C7C7C7", borderRadius: "4px", padding: "14px 16px" }}>
                                              <div className="d-flex justify-content-between align-items-center mb-2">
                                                <h6 className="mb-0 forteen proxima-regular">ASSESSMENT DATES</h6>
                                                <Button
                                                  type="button"
                                                  variant="transparent"
                                                  className="p-0 d-flex align-items-center gap-1 themeBlue"
                                                  onClick={() => openAssessmentDatesModal(item)}
                                                  title="Add assessment dates"
                                                >
                                                  <PlusCircle color="#315D99" />
                                                  Add date
                                                </Button>
                                              </div>
                                              {getAssessmentDates(item).length > 0 ? getAssessmentDates(item).map((assessmentDate, dateIndex) => {
                                                const value = typeof assessmentDate === "string" ? assessmentDate : assessmentDate?.assessment_date || assessmentDate?.date;
                                                const assessmentTime = typeof assessmentDate === "string" ? "" : assessmentDate?.assessment_time;
                                                const assessmentDateId = assessmentDate?.id || assessmentDate?.assessment_date_id || assessmentDate?.assessmentDateId;

                                                return (
                                                  <div key={assessmentDateId || `${value}-${dateIndex}`} className="d-flex align-items-center justify-content-between py-2 border-top">
                                                    <div className="d-flex flex-column gap-1">
                                                      <span className="proxima-regular d-flex align-items-center gap-1"><Calendar size={14}/> <div>{value ? dateFormat(value, "MMM DD, YYYY") : "--"}</div></span>
                                                      <span className="proxima-regular d-flex align-items-center gap-1"><Clock size={14}/><div>{assessmentTime ? dateFormat(assessmentTime, "hh:mm A", "hh:mm") : "--"}</div></span>
                                                    </div>
                                                    {assessmentDateId && (
                                                      <Button
                                                        type="button"
                                                        variant="transparent"
                                                        className="p-0 d-flex"
                                                        aria-label={`Delete assessment date ${value}`}
                                                        title="Delete assessment date"
                                                        onClick={() => {
                                                          setSelectedAssessmentDate(assessmentDate);
                                                          setModalType("deleteAssessmentDate");
                                                          setShowConfirmationModal(true);
                                                        }}
                                                      >
                                                        <Trash2 size={15} className="cursor-pointer" />
                                                      </Button>
                                                    )}
                                                  </div>
                                                );
                                              }) : <p className="mb-0 proxima-regular">No assessment dates assigned.</p>}
                                            </div>
                                          </td>
                                        </tr>
                                      )}
                                    </React.Fragment>
                                  );
                                }) :
                                <tr>
                                  <td colSpan="4" className="text-center px-0">
                                    <NoRecordFoundV2 />
                                  </td>
                                </tr>
                              }
                            </tbody>
                          </table>
                          {/* <table
                            className={`${styles.table} table mb-0`}
                            style={{ borderCollapse: "collapse" }}
                          >
                            <thead>
                              <tr className="">
                                <th className="text-dark p-2 fw-bold border-0 bg-transparent">
                                  Therapist
                                </th>
                                <th className="text-dark p-2 fw-bold border-0 bg-transparent">
                                  Discipline
                                </th>
                                <th className="text-dark p-2 fw-bold border-0 bg-transparent">
                                  Assessment Dates
                                </th>
                                <th className="text-dark p-2 fw-bold border-0 bg-transparent">
                                Meeting Time
                              </th>
                                <th className="text-dark p-2 fw-bold border-0 bg-transparent">
                                  Action
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {clientCaseloadTrerapist?.length > 0 ? (
                                clientCaseloadTrerapist?.map((item, index) => {
                                  return (
                                    <tr>
                                      <td className="p-2">
                                        <h6 className="fw-sbold themeBlue m-0">
                                          {userFullName(item?.clientCaseloadMapping?.[0]?.caseTherapist)}
                                        </h6>
                                      </td>
                                      <td className="p-2">{item?.caseDiscipline?.assign_term || "--"}</td>
                                      <td className="p-2">
                                        <Button
                                          className="border-0 p-0 d-flex align-items-center  themeBlue fw-sbold"
                                          variant="transparent"
                                        >
                                          {" "}
                                          <span className="icn me-1">
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="14"
                                              height="16"
                                              viewBox="0 0 14 16"
                                              fill="none"
                                            >
                                              <path
                                                d="M1.75 15.5C1.3375 15.5 0.984375 15.3531 0.690625 15.0594C0.396875 14.7656 0.25 14.4125 0.25 14V3.5C0.25 3.0875 0.396875 2.73438 0.690625 2.44063C0.984375 2.14688 1.3375 2 1.75 2H2.5V0.5H4V2H10V0.5H11.5V2H12.25C12.6625 2 13.0156 2.14688 13.3094 2.44063C13.6031 2.73438 13.75 3.0875 13.75 3.5V14C13.75 14.4125 13.6031 14.7656 13.3094 15.0594C13.0156 15.3531 12.6625 15.5 12.25 15.5H1.75ZM1.75 14H12.25V6.5H1.75V14ZM1.75 5H12.25V3.5H1.75V5ZM7 9.5C6.7875 9.5 6.60938 9.42813 6.46563 9.28438C6.32188 9.14062 6.25 8.9625 6.25 8.75C6.25 8.5375 6.32188 8.35938 6.46563 8.21563C6.60938 8.07188 6.7875 8 7 8C7.2125 8 7.39063 8.07188 7.53438 8.21563C7.67813 8.35938 7.75 8.5375 7.75 8.75C7.75 8.9625 7.67813 9.14062 7.53438 9.28438C7.39063 9.42813 7.2125 9.5 7 9.5ZM4 9.5C3.7875 9.5 3.60938 9.42813 3.46562 9.28438C3.32187 9.14062 3.25 8.9625 3.25 8.75C3.25 8.5375 3.32187 8.35938 3.46562 8.21563C3.60938 8.07188 3.7875 8 4 8C4.2125 8 4.39062 8.07188 4.53438 8.21563C4.67812 8.35938 4.75 8.5375 4.75 8.75C4.75 8.9625 4.67812 9.14062 4.53438 9.28438C4.39062 9.42813 4.2125 9.5 4 9.5ZM10 9.5C9.7875 9.5 9.60938 9.42813 9.46563 9.28438C9.32188 9.14062 9.25 8.9625 9.25 8.75C9.25 8.5375 9.32188 8.35938 9.46563 8.21563C9.60938 8.07188 9.7875 8 10 8C10.2125 8 10.3906 8.07188 10.5344 8.21563C10.6781 8.35938 10.75 8.5375 10.75 8.75C10.75 8.9625 10.6781 9.14062 10.5344 9.28438C10.3906 9.42813 10.2125 9.5 10 9.5ZM7 12.5C6.7875 12.5 6.60938 12.4281 6.46563 12.2844C6.32188 12.1406 6.25 11.9625 6.25 11.75C6.25 11.5375 6.32188 11.3594 6.46563 11.2156C6.60938 11.0719 6.7875 11 7 11C7.2125 11 7.39063 11.0719 7.53438 11.2156C7.67813 11.3594 7.75 11.5375 7.75 11.75C7.75 11.9625 7.67813 12.1406 7.53438 12.2844C7.39063 12.4281 7.2125 12.5 7 12.5ZM4 12.5C3.7875 12.5 3.60938 12.4281 3.46562 12.2844C3.32187 12.1406 3.25 11.9625 3.25 11.75C3.25 11.5375 3.32187 11.3594 3.46562 11.2156C3.60938 11.0719 3.7875 11 4 11C4.2125 11 4.39062 11.0719 4.53438 11.2156C4.67812 11.3594 4.75 11.5375 4.75 11.75C4.75 11.9625 4.67812 12.1406 4.53438 12.2844C4.39062 12.4281 4.2125 12.5 4 12.5ZM10 12.5C9.7875 12.5 9.60938 12.4281 9.46563 12.2844C9.32188 12.1406 9.25 11.9625 9.25 11.75C9.25 11.5375 9.32188 11.3594 9.46563 11.2156C9.60938 11.0719 9.7875 11 10 11C10.2125 11 10.3906 11.0719 10.5344 11.2156C10.6781 11.3594 10.75 11.5375 10.75 11.75C10.75 11.9625 10.6781 12.1406 10.5344 12.2844C10.3906 12.4281 10.2125 12.5 10 12.5Z"
                                                fill="#1C1B1F"
                                              />
                                            </svg>
                                          </span>
                                          {item?.assessment_date ? moment(item?.assessment_date).format("DD/MM/YYYY") : "--"}
                                        </Button>
                                      </td>
                                      <td className="p-2">
                                      {item?.meeting_time ? moment(item?.meeting_time, "HH:mm:ss").format("hh:mm A") : "--"}

                                    </td>
                                      <td className="p-2">
                                        <div className="ActnBtn d-flex align-items-center  gap-10">
                                          <Button
                                          className="p-0"
                                          variant="transparent"
                                          type="button"
                                          onClick={() => {
                                            setCurrentItem(item);
                                            setShowEditModal(true);
                                          }}
                                        >
                                          <EditIcon />
                                        </Button>
                                          <Button
                                            onClick={() => {
                                              setCurrentItem(item);
                                              setModalType("delete")
                                              setShowConfirmationModal(true);
                                            }}
                                            className="p-0"
                                            variant="transparent"
                                            type="button"
                                          >
                                            <DeleteIcon />
                                          </Button>
                                        </div>
                                      </td>
                                    </tr>
                                  )
                                })
                              ) : (
                                <tr>
                                  <td colSpan={5} className="text-center">No data found</td>
                                </tr>
                              )}
                            </tbody>
                          </table> */}
                        </div>
                      </div>
                    </Col>
                    <Col lg="12" className="my-2">
                      {/* <h5 className="m-0 themeBlue fw-bold pb-2">Checklist</h5> */}
                      <div style={{ border: "1px solid #C7C7C7", padding: "12px", borderRadius: "4px" }}>
                        <Row>
                          <Col lg='8'>
                            <div className="d-flex gap-2">
                              <h6 className="mb-0 forteen proxima-regular" style={{ marginTop: "3px" }}>CHECKLIST
                                {/* <span onClick={() => navigate(generatePath(CLINICIANS_HISTORY, { clientId, clientType }))} className="themeBlue cursor-pointer ten ms-2" style={{ textDecoration: "underline" }}>HISTORY</span> */}
                              </h6>
                            </div>
                          </Col>
                          <Col lg='4' className="text-end">
                            {/* <AddPlus isDisabled={isDisabled} onClick={() => !isDisabled && setAssignDisciplineModal(true)} /> */}
                          </Col>
                        </Row>
                        <div
                          className={`${styles.tableResponsive} tableResponsive table-responsive mb-3 pb-0`}
                        >
                          <table className="w-100">
                            <thead>
                              <tr>
                                <th
                                  className="fw-medium proxima"
                                  style={{ padding: "15px 10px", borderBottom: "2px solid #315D99", cursor: "pointer" }}
                                >
                                  <div>
                                    THERAPIST NAME
                                  </div>
                                </th>
                                <th
                                  className="fw-medium proxima"
                                  style={{ padding: "15px 10px", width: "120px", borderBottom: "2px solid #315D99", cursor: "pointer" }}
                                >
                                  <div>
                                    ACTION ITEM
                                  </div>
                                </th>
                                <th
                                  className="fw-medium proxima"
                                  style={{ padding: "15px 10px", borderBottom: "2px solid #315D99", cursor: "pointer" }}
                                >
                                  <div className={`d-flex gap-2 align-items-center`}>
                                    DEADLINE
                                  </div>
                                </th>
                                <th
                                  className="fw-medium proxima"
                                  style={{ padding: "15px 10px", borderBottom: "2px solid #315D99", cursor: "pointer" }}
                                >
                                  <div className={`d-flex gap-2 align-items-center`}>
                                    STATUS
                                  </div>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {checkList?.length > 0 ?
                                checkList?.map((item, index) => {
                                  return (
                                    <tr key={index}>
                                      <td
                                        style={{
                                          padding: "15px 10px",
                                          borderRadius: 0,
                                          borderBottom: "1px solid #8F8F8F",
                                        }}
                                      >
                                        <div className="d-flex gap-2 align-items-center">
                                          <img
                                            src={item?.therapist?.caseTherapist?.therapist_detail?.profile_picture || p1}
                                            alt=""
                                            className="img-fluid object-fit-cover rounded-circle border border-white"
                                            style={{ height: 30, width: 30 }}
                                          />
                                          <p className="p-0 m-0">
                                            {userFullName(item?.therapist?.caseTherapist)}
                                          </p>
                                        </div>
                                      </td>
                                      <td
                                        className="proxima"
                                        style={{
                                          padding: "15px 10px",
                                          borderRadius: 0,
                                          borderBottom: "1px solid #8F8F8F",
                                        }}
                                      >
                                        <p className="p-0 m-0">
                                          {/* <span className="icn me-1">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="9"
                                            height="9"
                                            viewBox="0 0 9 9"
                                            fill="none"
                                          >
                                            <circle
                                              cx="4.5"
                                              cy="4.5"
                                              r="4"
                                              fill="white"
                                              stroke="#00C874"
                                            />
                                          </svg>
                                        </span>{" "} */}
                                          {item?.action || "--"}
                                        </p>
                                      </td>
                                      <td
                                        style={{
                                          padding: "15px 10px",
                                          borderRadius: 0,
                                          borderBottom: "1px solid #8F8F8F",
                                        }}
                                      >
                                        <p className="p-0 m-0">{dateFormat(item?.deadline, "MMM DD, YYYY")}</p>
                                      </td>
                                      <td
                                        style={{
                                          padding: "15px 10px",
                                          borderRadius: 0,
                                          borderBottom: "1px solid #8F8F8F",
                                        }}
                                      >
                                        <Form.Select
                                          className="form-control"
                                          aria-label="Default select example"
                                          value={checkListStatusList?.find(x => x.id === item?.status)?.id}
                                          onChange={e => {

                                            setCurrentItem({ ...item, new_status: parseInt(e.target.value), caseload_therapist_id: item?.caseload_therapist_id });
                                            setModalType("update");
                                            setShowConfirmationModal(true);
                                          }}
                                        >
                                          {
                                            checkListStatusList?.map((item, index) => {
                                              return <option key={index} value={item.id}>{item?.title}</option>
                                            })
                                          }
                                        </Form.Select>
                                      </td>
                                    </tr>
                                  );
                                }) :
                                <tr>
                                  <td colSpan="4" className="text-center px-0">
                                    <NoRecordFoundV2 />
                                  </td>
                                </tr>
                              }
                            </tbody>
                          </table>
                          {/* <table
                          className={`${styles.table} table mb-0`}
                          style={{ borderCollapse: "collapse" }}
                        >
                          <thead>
                            <tr>
                              <th className="text-dark  fw-bold border-0">
                                Therapist Name
                              </th>
                              <th className="text-dark fw-bold border-0">
                                Action Item
                              </th>
                              <th className="text-dark fw-bold border-0">
                                Deadline
                              </th>
                              <th className="text-dark fw-bold border-0">
                                Status
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {
                              !checkList?.length ?
                                <tr><td colSpan={4}><NoRecordFound /></td></tr> :
                                checkList?.map((item, index) => {
                                  return <tr key={index}>
                                    <td className="p-2">
                                      <div className="d-flex align-items-center gap-10">
                                        <img
                                          src={item?.therapist?.caseTherapist?.therapist_detail?.profile_picture || p1}
                                          alt=""
                                          className="img-fluid object-fit-cover rounded-circle border border-white"
                                          style={{ height: 30, width: 30 }}
                                        />
                                        <h6 className="m-0 themeBlue fw-sbold">
                                          {userFullName(item?.therapist?.caseTherapist)}
                                        </h6>
                                      </div>
                                    </td>
                                    <td className="p-2">
                                      <p className="m-0 fw-sbold themeBlue">
                                        <span className="icn me-1">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="9"
                                            height="9"
                                            viewBox="0 0 9 9"
                                            fill="none"
                                          >
                                            <circle
                                              cx="4.5"
                                              cy="4.5"
                                              r="4"
                                              fill="white"
                                              stroke="#00C874"
                                            />
                                          </svg>
                                        </span>{" "}
                                        {item?.action || "--"}
                                      </p>
                                    </td>
                                    <td className="p-2">
                                      <p className="m-0 fw-sbold themeBlue">{convertToMomentDate(item?.deadline)}</p>
                                    </td>
                                    <td
                                      className="rounded-0 p-2"
                                    >
                                      <Form.Select
                                        className="form-control"
                                        aria-label="Default select example"
                                        value={checkListStatusList?.find(x => x.id === item?.status)?.id}
                                        onChange={e => {

                                          setCurrentItem({ ...item, new_status: parseInt(e.target.value), caseload_therapist_id: item?.caseload_therapist_id });
                                          setModalType("update");
                                          setShowConfirmationModal(true);
                                        }}
                                      >
                                        {
                                          checkListStatusList?.map((item, index) => {
                                            return <option key={index} value={item.id}>{item?.title}</option>
                                          })
                                        }
                                      </Form.Select>
                                    </td>
                                  </tr>
                                })
                            }
                          </tbody>
                        </table> */}
                        </div>
                      </div>
                    </Col>
                    <Col lg="12" className="my-2">
                      <div style={{ border: "1px solid #C7C7C7", padding: "12px", borderRadius: "4px" }}>
                        <Row>
                          <Col lg='8'>
                            <div className="d-flex gap-2">
                              <h6 className="mb-0 forteen proxima-regular" style={{ marginTop: "3px" }}>MDT TERMS
                                {/* <span onClick={() => navigate(generatePath(CLINICIANS_HISTORY, { clientId, clientType }))} className="themeBlue cursor-pointer ten ms-2" style={{ textDecoration: "underline" }}>HISTORY</span> */}
                              </h6>
                            </div>
                          </Col>
                          <Col lg='4' className="text-end">
                          </Col>
                        </Row>
                        {/* <h5 className="m-0 themeBlue fw-bold pb-2">MDT Terms</h5> */}
                        <div
                          className={`${styles.tableResponsive} tableResponsive table-responsive mb-3 pb-0`}
                        >
                          <table className="w-100">
                            <thead>
                              <tr>
                                <th
                                  className="fw-medium proxima"
                                  style={{ padding: "15px 10px", borderBottom: "2px solid #315D99", cursor: "pointer" }}
                                >
                                  <div>
                                    MDT TITLE
                                  </div>
                                </th>
                                <th
                                  className="fw-medium proxima"
                                  style={{ padding: "15px 10px", borderBottom: "2px solid #315D99", cursor: "pointer" }}
                                >
                                  <div>
                                    ACTION
                                  </div>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {mdtTerms?.length > 0 ?
                                mdtTerms?.map((item, index) => {
                                  return (
                                    <tr key={index}>
                                      <td
                                        className="proxima"
                                        style={{
                                          padding: "15px 10px",
                                          borderRadius: 0,
                                          borderBottom: "1px solid #8F8F8F",
                                        }}
                                      >
                                        <p className="p-0 m-0">
                                          {item?.title || "--"}
                                        </p>
                                      </td>
                                      <td
                                        style={{
                                          padding: "15px 10px",
                                          borderRadius: 0,
                                          borderBottom: "1px solid #8F8F8F",
                                        }}
                                      >
                                        <input
                                          type="checkbox"
                                          style={{ height: 20, width: 20 }}
                                          className="form-check"
                                          checked={clientDetails?.client_detail?.clientMdtDetail?.terms?.includes(item?.id)}
                                          onChange={e => handleCheckChange(item?.id)}
                                        />
                                      </td>
                                    </tr>
                                  );
                                }) :
                                <tr>
                                  <td colSpan="3" className="text-center px-0">
                                    <NoRecordFoundV2 title='Add a document' />
                                  </td>
                                </tr>
                              }
                            </tbody>
                          </table>
                          {/* <table className={`${styles.table} table mb-0`}>
                          <thead>
                            <tr>
                              <th className="text-dark fw-bold border-0 w-100">
                                MDT Title
                              </th>
                              <th className="text-dark fw-bold border-0">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {
                              mdtTerms?.map((item, index) => {

                                return (
                                  <tr key={index}>
                                    <td className="">
                                      <h6 className="m-0 fw-sbold themeBlue">
                                        {item?.title}
                                      </h6>
                                    </td>
                                    <td style={{ display: "block ruby" }} className="text-center">
                                      <input
                                        type="checkbox"
                                        style={{ height: 20, width: 20 }}
                                        className="form-check"
                                        checked={clientDetails?.client_detail?.clientMdtDetail?.terms?.includes(item?.id)}
                                        onChange={e => handleCheckChange(item?.id)}
                                      />
                                    </td>
                                  </tr>
                                )
                              })
                            }
                          </tbody>
                        </table> */}
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
          }
        </Container >
      </section >
    </>
  );
};

export default MultidisciplinaryDetail;
